/** @jsxImportSource @emotion/react */
import { Team } from '../../../../domain/intefaces';
import Advertisement from '../../../components/board/advertisement';
import Header from '../../../components/board/header';
import Period from '../../../components/board/period';
import Score from '../../../components/board/score';
import Timer from '../../../components/board/timer';
import TMLabel from '../../../components/tm-label';
import { LabelCss, MainBlock } from './styles';

interface IProps {
  teams: [Team, Team];
  period: number;
  time: number;
  roundTo: 'floor' | 'ceil';
}

function Desktop(props: IProps) {
  const { teams, period, time, roundTo } = props;

  return (
    <MainBlock>
      <Header value="ПРИВЕТСТВУЕМ УЧАСТНИКОВ ИГРЫ" />
      <div id="center" className="mt-12 flex w-full flex-row items-center justify-between">
        <Score id="score" score={teams[0].score} teamName={teams[0].name} />
        <div className="flex-center flex-col">
          <Period id="period" value={period} />
          <Timer id="timer" className="mt-8" milliseconds={time} roundTo={roundTo} />
          <TMLabel id="label" css={LabelCss} fontSize={62} style={{ marginTop: 20 }} />
        </div>
        <Score id="score" score={teams[1].score} teamName={teams[1].name} />
      </div>
      <Advertisement className="mt-14" />
    </MainBlock>
  );
}

export default Desktop;
